<template>
<div class="row">
  <div class="col-6">
    <h1>00. Perché scegliere Real Estate Pro</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087357?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="00 perche scegliere rep"></iframe></div>
  </div>

  <div class="col-6">
    <h1>01. Primo accesso</h1>

    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087396?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="01 primo accesso"></iframe></div>
  </div>

  <div class="col-6">
    <h1>02. Panoramica</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087420?badge=0&autopause=0&player_id=0&app_id=58479/embed" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen frameborder="0" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe></div>

  </div>

  <div class="col-6">
    <h1>03. Mappatura</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087317?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="03 mappatura"></iframe></div>
  </div>


  <div class="col-6">
    <h1>04. Aggiornamento e cancellazione immobile</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087241?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="04 aggiornamento e cancellazione immobile"></iframe></div>
  </div>

  <div class="col-6">
    <h1>05. Gestione cartelle</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087277?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="05 gestione cartelle"></iframe></div>
  </div>

  <div class="col-6">
    <h1>06. Come individuare le operazioni</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087300?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="06 come individuare le operazioni"></iframe></div>
  </div>

  <div class="col-6">
    <h1>07. Aste</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087187?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="07 aste"></iframe></div>
  </div>

  <div class="col-6">
    <h1>08. My Team</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087206?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="08 my team"></iframe></div>
  </div>

  <div class="col-6">
    <h1>09. My Task</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087163?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="09 my task"></iframe></div>
  </div>
  <div class="col-6">
    <h1>10. Conto Economico</h1>
    <div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/836087454?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="position:absolute;top:0;left:0;width:100%;height:100%;" title="10 conto economico"></iframe></div>
  </div>
</div>


</template>

<script>
import NBread from "@/partials/bread";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  components: {
    NBread,
  },
  computed: {
    ...mapState("n_tutorial", ["bread_active", "bread_list"]),
  },
  created() {
    this.lang = window.localStorage.getItem("language");
    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Los Videotutoriales de Real Estate Pro" },
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "I Video Tutorial di Real Estate Pro" },
      });
    }
  },
  methods: {
    ...mapActions("n_tutorial", [""]),
    ...mapMutations("n_tutorial", ["SET_DATA"]),
    checkLanguage(x) {
      if (this.lang === x) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
